<template>
  <div>
    <ManageTeamModal
      :show.sync="showTeamModal"
      v-if="showTeamModal"
      :entry="entry"
      @close-modal="showTeamModal = false"
    ></ManageTeamModal>

    <b-table
      class="has-margin-top-15"
      :data="entries"
      :narrowed="true"
      :hoverable="true"
      :mobile-cards="false"
    >
      <template slot-scope="props">
        <b-table-column
          label="#"
          field="entrynumber"
          :sortable="true"
          :custom-sort="sortEntryNumbers"
        >
          {{ props.row.entrynumber }}
        </b-table-column>
        <b-table-column label="Category" field="category" :sortable="true">
          {{ props.row.category }}
        </b-table-column>
        <b-table-column label="Name" field="firstname" :sortable="true">
          <strong>{{ props.row.teamname }}</strong>
          -
          <a
            :href="`/athlete/${props.row.user._id}`"
            class="has-text-weight-bold"
            target="_blank"
            v-if="!props.row.dependant"
            >{{ props.row.user.firstname }} {{ props.row.user.surname }}</a
          >
          <a
            :href="`/athlete/${props.row.user._id}/${props.row.dependant._id}`"
            class="has-text-weight-bold"
            target="_blank"
            v-if="props.row.dependant"
            >{{ props.row.dependant.firstname }}
            {{ props.row.dependant.surname }} ({{ props.row.user.firstname }}
            {{ props.row.user.surname }})</a
          >
          <div>
            <a :href="`mailto:${props.row.user.email}`">{{
              props.row.user.email
            }}</a>
          </div>
          <div>{{ props.row.gymname }}</div>
        </b-table-column>
        <b-table-column label="Age" field="dob" :sortable="true">
          <span v-if="!props.row.dependant">{{
            props.row.user.dob | age
          }}</span>
          <span v-if="props.row.dependant">{{
            props.row.dependant.dob | age
          }}</span>
        </b-table-column>
        <b-table-column
          v-if="!waitinglist"
          label="Paid"
          field="paid"
          :sortable="true"
        >
          <b-icon
            v-if="props.row.paid"
            class="has-text-success"
            icon="check"
          ></b-icon>
          <b-icon
            v-if="!props.row.paid"
            class="has-text-danger"
            icon="close"
          ></b-icon>
          <a
            style="display: block"
            target="_blank"
            v-if="props.row.paymentmethod === 'EFT' && props.row.eftpop"
            :href="props.row.eftpop"
            ><small>View POP</small></a
          >
          <small
            style="display: block"
            v-if="props.row.paymentmethod === 'EFT' && !props.row.eftchecked"
            class="has-text-danger"
            >Unverified</small
          >
        </b-table-column>
        <b-table-column label="Registered" field="datecreated" :sortable="true">
          {{ props.row.datecreated | formatDateTime }}
        </b-table-column>
        <b-table-column label="">
          <EntryActions
            v-if="!waitinglist"
            :entry.sync="props.row"
            :event="event"
            @deleted="removeEntry"
            @show-team-modal="viewTeamModal"
          />
          <WaitingListActions
            v-else
            :entry.sync="props.row"
            :event="event"
            @deleted="removeEntry"
            @show-team-modal="viewTeamModal"
          />
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import EntryActions from '@/components/EntryActions'
import WaitingListActions from '@/components/WaitingListActions'
import Filters from '@/mixins/filters'
import ManageTeamModal from '@/components/ManageTeamModal'

export default {
  name: 'TeamEntries',
  components: {
    EntryActions,
    WaitingListActions,
    ManageTeamModal,
  },
  mixins: [Filters],
  props: {
    entries: {
      type: Array,
      default: () => [],
    },
    event: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      waitinglist: this.$route.name === 'ManageWaitingList',
      entry: {},
      showTeamModal: false,
    }
  },
  methods: {
    viewTeamModal(entry) {
      this.entry = entry
      this.showTeamModal = true
    },
    removeEntry(entryId) {
      this.$emit('deleted', entryId)
    },
    sortEntryNumbers(a, b, asc) {
      if (asc) {
        return parseInt(a.entrynumber, 10) - parseInt(b.entrynumber, 10)
      } else {
        return parseInt(b.entrynumber, 10) - parseInt(a.entrynumber, 10)
      }
    },
  },
}
</script>
